import * as React from 'react';
/**
 * Disables given callback when disabled parameter is truthy
 */

var useDisabledCallback = function useDisabledCallback(callback, disabled) {
  return React.useCallback(function () {
    if (disabled) return;
    callback.apply(void 0, arguments);
  }, [callback, disabled]);
};

export { useDisabledCallback };